import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/crayon-1.svg';
export default {
  name: 'GlobalArticleCard',
  props: {
    slug: {
      type: String,
      required: true
    },
    image: {
      type: Object,
      required: true
    },
    tags: {
      type: Array,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    readingTime: {
      type: Number,
      required: true
    },
    difficulty: {
      type: Number,
      required: true
    },
    colorBorder: {
      type: String,
      default: '#fff'
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  methods: {
    formatArticleUrl(arg) {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/e/article/").concat(arg);
    },

    formatDate(arg) {
      const date = new Date(arg);
      const locale = "".concat(this.locale.language, "-").concat(this.locale.market);
      const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      };
      return date.toLocaleDateString(locale, options);
    }

  }
};